import { OnDestroy, OnInit } from '@angular/core';
import { APP_DATE_FORMATS } from '../../../_pipes/angular2-material-datepicker-custom-date';
import { PlanningService } from '../../../_services/planning.service';
import { MatDialog } from '@angular/material';
import { addDays, eachDayOfInterval, endOfWeek, format, isSameDay, parseISO, startOfWeek } from 'date-fns';
import { nl } from 'date-fns/locale';
import { ModalPlanningViewComponent } from './modal-planning-view/modal-planning-view.component';
const ɵ0 = APP_DATE_FORMATS;
export class PlanningListComponent {
    constructor(planningService, dialogService) {
        this.planningService = planningService;
        this.dialogService = dialogService;
        this.view = 'week';
        this.currentDate = new Date();
        this.days = [];
        this.events = [];
        this.eventsMap = {};
    }
    ngOnInit() {
        this.getPlanning();
    }
    ngOnDestroy() {
    }
    buildEventsMap() {
        this.eventsMap = {};
        for (const event of this.events) {
            const start = new Date(event.start_at);
            let end = new Date(event.end_at || event.start_at); // fallback if end missing
            if (end < start) {
                end = start; // make end same as start if end comes before start
            }
            const days = eachDayOfInterval({ start, end });
            for (const day of days) {
                const key = format(day, 'yyyy-MM-dd');
                if (!this.eventsMap[key]) {
                    this.eventsMap[key] = [];
                }
                this.eventsMap[key].push(event);
            }
        }
        this.generateWeek();
    }
    getEventsForDay(date) {
        return this.eventsMap[format(date, 'yyyy-MM-dd')] || [];
    }
    hasEvents(date) {
        return this.getEventsForDay(date).length > 0;
    }
    changeWeek(amount) {
        this.currentDate = addDays(this.currentDate, amount * 7);
        this.getPlanning();
    }
    generateWeek() {
        const start = startOfWeek(this.currentDate, { weekStartsOn: 1 });
        this.days = [];
        for (let i = 0; i < 7; i++) {
            this.days.push(addDays(start, i));
        }
    }
    getWeekRange(date) {
        const start = startOfWeek(date, { weekStartsOn: 1 });
        const end = endOfWeek(date, { weekStartsOn: 1 });
        const startFormatted = format(start, 'd. MMM', { locale: nl });
        const endFormatted = format(end, 'd. MMM yy', { locale: nl });
        return `${startFormatted} – ${endFormatted}`;
    }
    getDayFormat(date) {
        const formatted = format(date, 'EEEE, d MMMM yyyy', { locale: nl });
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    }
    startAndEndNotInSameDay(event) {
        return !isSameDay(parseISO(event.start_at), parseISO(event.end_at));
    }
    viewEvent(event) {
        this.dialogService.open(ModalPlanningViewComponent, {
            data: event
        });
    }
    getPlanning() {
        this.planningService.getPlannings({
            start: format(startOfWeek(this.currentDate, { weekStartsOn: 1 }), 'yyyy-MM-dd'),
        }).then((data) => {
            if (typeof data !== 'undefined' && typeof data.data !== 'undefined') {
                this.events = data.data.map((e) => (Object.assign({}, e, { date: new Date(e.start_at) })));
            }
            this.buildEventsMap();
        });
    }
}
export { ɵ0 };
